// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import * as z from 'zod';
import { organizationSchema, personSchema } from '@/account/api/types';

export const userSchema = personSchema.extend({
  email: z.string(),
  organization: organizationSchema,
  isAdmin: z.boolean(),
  userGroups: z.array(z.string()),
  activePolicy: z.array(z.string()).nullable(),
});

export type User = z.infer<typeof userSchema>;

export type AuthenticationSSOProvider = 'google' | 'azureadv2';
